module.exports = __webpack_public_path__ + "img/euro_games.5bfc157d.svg";